import React, { useState, Suspense, lazy, useEffect } from "react";
import { Location, Redirect } from "@reach/router";

import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";

import Header from "./Header/Index";
import HomePage from "./pages/HomePage/HomePage";
import Body from "./Body/index";

import { createGlobalStyle } from "styled-components";
import Web3ModalProvider from "contexts/Web3ModalProvider";
import Web3WrapperProvider from "contexts/Web3WrapperProvider";

import IPFSProvider from "contexts/IPFSProvider";

import "./home.scss";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Typography } from "@mui/material";

const GlobalStyles = createGlobalStyle`
  :root {
    scroll-behavior: unset;
  }
`;

export const ScrollTop = ({ children, location }): any => {
  React.useEffect(() => window.scrollTo(0, 0), [location]);
  return children;
};

const app = () => (
  <Web3ModalProvider>
    <NotificationContainer />
    <Web3WrapperProvider>
      <IPFSProvider>
        <div className="home ">
          <HomePage />
          <div className="homeContainer home-bg ">
            <Header />

            <Body />
          </div>
        </div>
      </IPFSProvider>
    </Web3WrapperProvider>
  </Web3ModalProvider>
);
export default app;
